// extracted by mini-css-extract-plugin
export default {"melodyVideo":"NO-z","isFullWidth":"OO-z","landingPageVideo":"PO-z","play":"QO-z","iframeVideo":"RO-z","playHidden":"SO-z","fullwidth":"TO-z"};